import { useEffect, useState, type ReactNode } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { authFetch } from "../../utils/authFetch";

/** Holds a directly opened docs link until we know whether it moved. Left to the
 *  reader, an old section falls back to the first page, and that navigation can
 *  win the race against the redirect. */
export default function MovedGate({ children }: { children: ReactNode }) {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { pathname, search, hash } = useLocation();
  const prefix = `/docs/projects/${projectSlug}/`;
  const path = pathname.startsWith(prefix) ? pathname.slice(prefix.length).replace(/\/$/, "") : "";
  const [checked, setChecked] = useState(false);
  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    if (checked) return;
    if (!path) { setChecked(true); return; }
    let cancelled = false;
    authFetch(`/api/docs/${projectSlug}/moved?path=${encodeURIComponent(path)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled) { setTarget(d?.path ?? null); setChecked(true); } })
      .catch(() => { if (!cancelled) setChecked(true); });
    return () => { cancelled = true; };
    // Once per open: links inside the app go through useMovedRedirect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!checked) return null;
  if (target && target !== path) return <Navigate to={`${prefix}${target}${search}${hash}`} replace />;
  return <>{children}</>;
}
